export const environment = {
  production: true,
  apiBase: 'https://www.cakalnedobe.si/wp-json',
  baseUrl: '/urejanje-podatkov-izvajalca',
  premiumFlyerUrl: 'https://www.cakalnedobe.si/premium-profil/',
  faqUrl: 'https://www.cakalnedobe.si/premium-pogosta-vprasanja/',
};
